const priorityConfig = {
  Highest:    { color: "#c62828", bg: "#ffebee" },
  High:       { color: "#e65100", bg: "#fff3e0" },
  Normal:     { color: "#2e7d32", bg: "#e8f5e9" },
  Low:        { color: "#1565c0", bg: "#e3f2fd" },
  Nicetohave: { color: "#616161", bg: "#f5f5f5" },
};

const TicketTable = ({ tickets, label }) => {
  if (!tickets || tickets.length === 0) return null;

  return (
    <div style={{ marginBottom: "16px" }}>
      <div style={{
        fontSize: "0.72rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: "#9e9e9e",
        marginBottom: "8px",
        paddingLeft: "4px",
      }}>
        {label}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {tickets.map((ticket) => {
          const p = priorityConfig[ticket.action.priority] || priorityConfig.Nicetohave;
          return (
            <div key={ticket.action.id} style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#f8f9fa",
              borderRadius: "8px",
              padding: "8px 12px",
              gap: "10px",
            }}>
              <span style={{ fontWeight: 600, fontSize: "0.85rem", color: "#212121", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {ticket.action.title}
              </span>
              <span style={{
                background: p.bg,
                color: p.color,
                fontSize: "0.7rem",
                fontWeight: 700,
                padding: "2px 8px",
                borderRadius: "20px",
                flexShrink: 0,
              }}>
                {ticket.action.priority}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TicketTable;
